import NodeJs from "../../assets/Images/Skills/icons8-node-js.svg";
import ExpressJS from "../../assets/Images/Skills/express.svg";
import ReactJs from "../../assets/Images/Skills/icons8-react-native.svg";
import MongoDB from "../../assets/Images/Skills/icons8-mongodb.svg";
import MaterialUI from "../../assets/Images/Skills/icons8-material-ui.svg";
import TailWindCSS from "../../assets/Images/Skills/icons8-tailwind-css.svg";

// devops and cloud

import Docker from "../../assets/Images/Skills/icons8-docker.svg";
import Kubernetes from "../../assets/Images/Skills/icons8-kubernetes.svg";
import Vagrant from "../../assets/Images/Skills/icons8-vagrant-an-open-source-software-product-for-building-and-maintaining-portable-virtual-software-96.png";
import Jenkins from "../../assets/Images/Skills/icons8-jenkins.svg";
import Linux from "../../assets/Images/Skills/Linux.svg";
import Bash from "../../assets/Images/Skills/pngegg.png";
import AWS from "../../assets/Images/Skills/icons8-amazon-web-services.svg";
import Azure from "../../assets/Images/Skills/icons8-azure.svg";
import GitHub from "../../assets/Images/Skills/icons8-github.svg";
import OpenCL from "../../assets/Images/Skills/OpenCL.png";
import Slurm from "../../assets/Images/Skills/Slurm.png";
import Illustrator from "../../assets/Images/Skills/Illustrator.png";
import Figma from "../../assets/Images/Skills/Figma.png";
import DearIGUI from "../../assets/Images/Skills/DearImGUI.jpg";
import PHP from "../../assets/Images/Skills/PHP-logo.png";
import Flutter from "../../assets/Images/Skills/Flutter_logo.png";
import Cpp from "../../assets/Images/Skills/CPlusPlus.webp";

// Certification
import UdemyLogo from "../../assets/Images/certifications/Udemy.png";
import CourseraLogo from "../../assets/Images/certifications/Coursera.png";

const AWSLogo =
  "https://raw.githubusercontent.com/belanasaikiran/belanasaikiran.github.io/refs/heads/jan2026/src/assets/Images/certifications/aws.png";

const CodePathLogo =
  "https://newprofit.org/wp-content/uploads/2024/09/CodePath-Logo-Circle.png";

const NCL_logo =
  "https://www.competitionsciences.org/wp-content/uploads/2020/01/National-Cyber-League-Logo.png";

export const AllSkills = [
  {
    skillName: "C++",
    Icon: Cpp,
  },
  {
    skillName: "Yocto - Linux",
    Icon: Linux,
  },
  {
    skillName: "Bash",
    Icon: Bash,
  },

  {
    skillName: "Docker",
    Icon: Docker,
  },
  {
    skillName: "Kubernetes",
    Icon: Kubernetes,
  },
  {
    skillName: "NodeJs",
    Icon: NodeJs,
  },
  {
    skillName: "ExpressJs",
    Icon: ExpressJS,
  },
  {
    skillName: "ReactJs",
    Icon: ReactJs,
  },

  {
    skillName: "MongoDB",
    Icon: MongoDB,
  },

  {
    skillName: "MaterialUI",
    Icon: MaterialUI,
  },
  {
    skillName: "TailwindCSS",
    Icon: TailWindCSS,
  },
  {
    skillName: "Figma",
    Icon: Figma,
  },
  {
    skillName: "Adobe Illustrator",
    Icon: Illustrator,
  },

  {
    skillName: "Vagrant",
    Icon: Vagrant,
  },
  {
    skillName: "Jenkins",
    Icon: Jenkins,
  },

  {
    skillName: "AWS",
    Icon: AWS,
  },
  {
    skillName: "Azure",
    Icon: Azure,
  },
  {
    skillName: "GitHub",
    Icon: GitHub,
  },
  {
    skillName: "OpenCL",
    Icon: OpenCL,
  },
  {
    skillName: "Slurm",
    Icon: Slurm,
  },
  {
    skillName: "Dear ImGui",
    Icon: DearIGUI,
  },
  {
    skillName: "PHP",
    Icon: PHP,
  },
  {
    skillName: "Flutter",
    Icon: Flutter,
  },
];

// Ref
export const FullStackSkills = [
  {
    skillName: "NodeJs",
    Icon: NodeJs,
  },
  {
    skillName: "ExpressJs",
    Icon: ExpressJS,
  },
  {
    skillName: "ReactJs",
    Icon: ReactJs,
  },

  {
    skillName: "MongoDB",
    Icon: MongoDB,
  },

  {
    skillName: "MaterialUI",
    Icon: MaterialUI,
  },
  {
    skillName: "TailwindCSS",
    Icon: TailWindCSS,
  },
];

export const CloudDevOpsSkills = [
  {
    skillName: "Docker",
    Icon: Docker,
  },
  {
    skillName: "Kubernetes",
    Icon: Kubernetes,
  },
  {
    skillName: "Vagrant",
    Icon: Vagrant,
  },
  {
    skillName: "Jenkins",
    Icon: Jenkins,
  },
  {
    skillName: "Linux",
    Icon: Linux,
  },
  {
    skillName: "Bash",
    Icon: Bash,
  },
  {
    skillName: "AWS",
    Icon: AWS,
  },
  {
    skillName: "Azure",
    Icon: Azure,
  },
  {
    skillName: "GitHub",
    Icon: GitHub,
  },
  {
    skillName: "OpenCL",
    Icon: OpenCL,
  },
];

export const Certificates = [
  {
    Image: AWSLogo,
    Course: "AWS Cloud Technical Essentials",
    DateOfCompletion: "Jan 2026",
    CredentialID: "06RAJX102HHH",
    VerifyLink:
      "https://www.coursera.org/account/accomplishments/verify/06RAJX102HHH",
  },
  {
    Image: CodePathLogo,
    Course: "Android Development",
    DateOfCompletion: "Dec 2025",
    CredentialID: "347812",
    VerifyLink:
      "https://drive.google.com/file/d/1V-TcjH2lZMpperS-7pCqMhloO1lBSqiA/view",
  },
  {
    Image: CodePathLogo,
    Course: "Technical Interview Prep(Advanced)",
    DateOfCompletion: "Dec 2025",
    CredentialID: "352244",
    VerifyLink:
      "https://drive.google.com/file/d/18ceUbF3P44ER3DAsgv5XUUw4reETpldG/view",
  },
  {
    Image: NCL_logo,
    Course: "NCL Spring 2025 Team Game",
    DateOfCompletion: "May 2025",
    CredentialID: "7K5JUJQPLXJL",
    VerifyLink: "https://cyberskyline.com/report/7K5JUJQPLXJL",
  },
  {
    Image: UdemyLogo,
    Course: "The Complete Web Development BootCamp - Angela Yu ",
    DateOfCompletion: "March 2023",
    CredentialID: " UC-b5330826-5ac1-4a14-ab24-1c5fa4c12bc7",
    VerifyLink:
      "https://www.udemy.com/certificate/UC-b5330826-5ac1-4a14-ab24-1c5fa4c12bc7/",
  },

  {
    Image: UdemyLogo,
    Course: "Docker Mastery: with Kubernetes + Swarm from a Docker Captain ",
    DateOfCompletion: "Jan 2022",
    CredentialID: " UC-18f9c634-dda4-4d81-bb0f-71907de16cd5",
    VerifyLink:
      "https://www.udemy.com/certificate/UC-18f9c634-dda4-4d81-bb0f-71907de16cd5/",
  },
  // {
  //   Image: CourseraLogo,
  //   Course: "Azure: Create a Virtual Machine and Deploy a Web Server",
  //   DateOfCompletion: "December 2022",
  //   CredentialID: " EQ86HGC9DYM2",
  //   VerifyLink:
  //     "https://www.coursera.org/account/accomplishments/verify/EQ86HGC9DYM2",
  // },
];
